var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportUnselected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "20px",
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "report_unselected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-/-icons-/-rapports-(black)",
    transform: "translate(-1.000000, -1.000000)",
    fill: "#172134",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0000234,5.756996 L17.0000234,7.756996 L17.0000234,3 L8.00004312,3 L8.00004312,8 L3.00004312,8 L3.00004312,18.999986 L17.0000234,18.999986 L17.0000234,16.242986 L19.0000234,14.242986 L19.0000234,20.007986 C18.9998231,20.271186 18.8950231,20.523486 18.7088231,20.709486 C18.5226231,20.895486 18.2702231,20.999986 18.0070231,20.999986 L1.99304312,20.999986 C1.86172312,20.999086 1.73187312,20.972286 1.61089312,20.921186 C1.48991812,20.870086 1.38019312,20.795686 1.28798412,20.702186 C1.19577512,20.608686 1.12288712,20.497886 1.07348312,20.376186 C1.02407812,20.254586 0.999125119,20.124286 1.00002342,19.992986 L1.00002342,7 L7.00305312,1 L17.9980231,1 C18.5500231,1 19.0000234,1.454996 19.0000234,1.991996 L19.0000234,5.756996 Z M19.7780231,7.806996 L21.1920231,9.221996 L13.4140231,16.999986 L11.9980231,16.997986 L12.0000231,15.585986 L19.7780231,7.807996 L19.7780231,7.806996 Z",
    id: "report_unselected"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportUnselected);
export default __webpack_public_path__ + "static/media/report_unselected.975abd47a08189b01f449b80e9a791bd.svg";
export { ForwardRef as ReactComponent };